import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { EmptyIconDirective } from '../../../components/datatable/components/empty/empty-icon.directive';
import { EmptyComponent } from '../../../components/datatable/components/empty/empty.component';
import { EmptySubHeaderComponent } from '../../../components/datatable/components/empty/empty-sub-header.component';

@Component({
  selector: 'td-wb-w8ben-form-error',
  templateUrl: 'w8ben-form-error.component.html',
  styleUrls: ['./w8ben-form-error.component.scss'],
  imports: [
    IconComponent,
    EmptyComponent,
    EmptySubHeaderComponent,
    EmptyIconDirective,
    TranslateDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class W8BenFormErrorComponent {
  readonly submitError: InputSignal<boolean> = input<boolean>(false);
}

